import { render, staticRenderFns } from "./EmployeeTraining.vue?vue&type=template&id=4cc2f9e8&scoped=true&"
import script from "./EmployeeTraining.vue?vue&type=script&lang=js&"
export * from "./EmployeeTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc2f9e8",
  null
  
)

export default component.exports